import { render, staticRenderFns } from "./base-input-v2.vue?vue&type=template&id=234ac6b5&"
import script from "./base-input-v2.vue?vue&type=script&lang=js&"
export * from "./base-input-v2.vue?vue&type=script&lang=js&"
import style0 from "./base-input-v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports